/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Hub_Group_SpecsInputs */

const en_hub_group_specs = /** @type {(inputs: Hub_Group_SpecsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Spec frameworks`)
};

const id_hub_group_specs = /** @type {(inputs: Hub_Group_SpecsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kerangka spesifikasi`)
};

/**
* | output |
* | --- |
* | "Spec frameworks" |
*
* @param {Hub_Group_SpecsInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const hub_group_specs = /** @type {((inputs?: Hub_Group_SpecsInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Hub_Group_SpecsInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_hub_group_specs(inputs)
	return en_hub_group_specs(inputs)
});